<template>
  <router-link
    class="sidebar-link sidebar-link-without-dropdown d-flex align-items-center position-relative"
    :class="{
      'is-inactive':!!isInactive,
      'is-active': active,
      'navbar-expanded': navbar_expanded,
    }"
    :to="to"
  >
    <span class="sidebar-link__icon">
      <slot
        v-if="img"
        name="img"
      />
      <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
      >
        <slot name="icon" />
      </svg>
    </span>
    
    <span
      class="sidebar-link__text show-expanded pl-1"
    >{{ text }}</span> 
  </router-link>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    to: {
      type: [String,Object],
      default: null,
    },
    isInactive: {
      type: Boolean,
      default: false,
    },
    img: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters(['navbar_expanded']),
    active() {
      return (this.$route.path === this.to || this.$route.name === this.to.name) && !this.isInactive
    },
  }
}
</script>
<style lang="scss" scoped>
.sidebar-link {
    .sidebar-link__text{
      display: none;
      opacity: 0;
    }
    &.navbar-expanded {
      width: 320px;
      .sidebar-link__text{
        display: inline-block;
        opacity: 1;
      }
    }
    &:hover {
      width: 320px;
      z-index: 9999;
      .sidebar-link__text{
        display: inline-block;
        opacity: 1;
      }
    }
}
.is-active{
  background-color: #c7cae0;
}
</style>